export enum PaymentAnimationStates {
  progress = 'progress',
  success = 'success',
  error = 'error',
}
